/**
 * Created by Andrey Popov on 19.12.2024
 */

const MergeComponent = function (unit) {
    UnitComponent.call(this, unit);
};

MergeComponent.prototype = Object.create(UnitComponent.prototype);
MergeComponent.prototype.constructor = MergeComponent;

MergeComponent.prototype.handleDragMove = function (x, y, cellsInRadius) {
    let isErrorLight, wrongCrystalMerged;

    let affected = this.findList(cellsInRadius, this.listMergeAtPoint.bind(this));

    if (!affected) {
        isErrorLight = true;

        affected = this.findList(cellsInRadius, this.listSameItemsGroup.bind(this));
        if (!affected && this.unit.isMagicCrystal()) {
            affected = this.findList(cellsInRadius, this.listDisableCrystalUnitsAtPoint.bind(this));
            wrongCrystalMerged = affected && affected[0];
        }
    }

    if (affected) {
        x = affected[0].x;
        y = affected[0].y;
    }

    if (this.unit.dragX === x && this.unit.dragY === y) {
        return true;
    }

    this.unit.dragX = x;
    this.unit.dragY = y;

    this.unhighlightMerge();
    this.hideMergeCount();

    if (affected) {
        this.unit.onMarkNormal();
        if (this.unit.light) {
            this.unit.light.hide();
        }

        if (!isErrorLight) {
            this.showMergeCount({ x: this.unit.x, y: this.unit.y, count: affected.length + 1 });
        }

        cleverapps.centerHint.create({
            unit: this.unit,
            amount: affected.length + 1,
            wrongMerged: isErrorLight,
            wrongCrystalMerged
        });

        isErrorLight ? this.highlightMergeError(affected) : this.highlightMerge(affected);

        if (this.unit.light) {
            this.unit.light.move(x, y);
        }

        return true;
    }
};

MergeComponent.prototype.findList = function (cells, filter) {
    for (let i = 0; i < cells.length; i++) {
        const cell = cells[i];
        const list = filter(cell.x, cell.y);
        if (list) {
            return list;
        }
    }
};

MergeComponent.prototype.handleDragEnd = function (x, y) {
    const mergeInfoUnit = Map2d.currentMap.getUnit(x, y);
    const affected = this.listMergeAtPoint(x, y);

    this.unhighlightMerge();

    if (!affected) {
        return false;
    }

    const needConfirmation = this.unit.isMagicCrystal() && !cleverapps.gameModes.skipOpenChestWindow
        && (Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial && !Map2dLocation.currentLocation.tutorial.isActive() && !cleverapps.tutorial.isActive());

    if (needConfirmation) {
        const amount = mergeInfoUnit.findComponent(MergeComponent).mergeBonus(affected.length + 1).bonus;
        cleverapps.focusManager.display({
            stack: true,
            focus: "ConfirmMergeWindow",
            action: function (f) {
                new ConfirmMergeWindow(this.unit, mergeInfoUnit, amount, ((confirmed) => {
                    if (confirmed) {
                        Map2dLocation.currentLocation.merge(affected, this.unit, mergeInfoUnit);
                    } else {
                        this.unit.dragX = undefined;
                        this.unit.dragY = undefined;
                        this.unit.onMove();
                        this.hideMergeCount();
                    }
                }));

                cleverapps.focusManager.onceNoWindowsListener = f;
            }.bind(this)
        });
    } else {
        Map2dLocation.currentLocation.merge(affected, this.unit, mergeInfoUnit);
    }

    return true;
};

MergeComponent.prototype.highlightMergeError = function (affected) {
    if (this.view) {
        this.view.highlightMergeError(affected);
    }
};

MergeComponent.prototype.highlightMergeHint = function (affected) {
    if (this.view) {
        this.view.highlightMergeHint(affected);
    }
};

MergeComponent.prototype.highlightMerge = function (affected) {
    if (this.view) {
        this.view.highlightMerge(affected);
    }
};

MergeComponent.prototype.unhighlightMerge = function () {
    if (this.view) {
        this.view.unhighlightMerge();
    }
};

MergeComponent.prototype.showMergeCount = function (affected) {
    if (this.view) {
        this.view.showMergeCount(affected);
    }
};

MergeComponent.prototype.hideMergeCount = function () {
    if (this.view) {
        this.view.hideMergeCount();
    }
};

MergeComponent.prototype.listMergeAtPoint = function (x, y) {
    if (cleverapps.config.editorMode) {
        return undefined;
    }

    const map = Map2d.currentMap;
    const mergingUnit = map.getUnit(x, y);

    let affected = [];
    if (mergingUnit && map.isGround(x, y) && !map.getFog(x, y) && this.unit.isMergeable(mergingUnit, true)) {
        affected = map.bfs(x, y, map.compareMergeable.bind(map, mergingUnit));
    }

    if (affected.length >= 2) {
        return affected;
    }
};

MergeComponent.prototype.listDisableCrystalUnitsAtPoint = function (x, y) {
    const map = Map2d.currentMap;
    const unit = map.getUnit(x, y);

    let affected = [];
    if (unit && map.isGround(x, y) && !map.getFog(x, y) && Unit.DISABLED_MERGABLE_UNITS_FOR_CRYSTAL.includes(unit.code)) {
        affected = map.bfs(x, y, map.compareMergeable.bind(map, unit));
    }

    if (affected.length >= 2) {
        return affected;
    }
};

MergeComponent.prototype.listSameItemsGroup = function (x, y) {
    const map = Map2d.currentMap;
    const mergingUnit = map.getUnit(x, y);

    let affected = [];
    if (map.compareEqual(this.unit, x, y)) {
        affected = map.bfs(x, y, map.compareEqual.bind(map, mergingUnit));
    }

    if (affected.length >= 2) {
        return affected;
    }
};

MergeComponent.prototype.mergeBonus = function (mergeAmount) {
    let prize = 0;
    let next = 5;
    const stages = Families[this.unit.code].units;

    if (mergeAmount >= 3 && stages[this.unit.stage].heroitem && this.unit.stage === stages.length - 2) {
        prize = 1;
        mergeAmount -= 3;
    } else {
        while (mergeAmount >= 3) {
            let merging = 3;
            let p = 1;
            while (mergeAmount >= 2 * merging - 1) {
                p *= 2;
                merging = 2 * merging - 1;
            }
            if (next === 5) {
                next = 2 * merging - 1;
            }

            mergeAmount -= merging;
            prize += p;
        }
    }

    return {
        bonus: prize,
        keepLast: mergeAmount,
        next
    };
};